import axios from "axios";
export const RS_LABEL=()=>{return (<span className='fw-bold'>&#8377;</span>);}
export const DDMMYYYY_LABEL=()=>{return (<span className='fw-bold'>yyyy-mm-dd</span>);}
//export const API_CORE_SERVER="http://localhost/ramgarh";
export const API_CORE_SERVER="https://ramgarhgramsampati.in";
export const URLPREFIX="";
export const NT_STATUS={
	"ERR_BAD_REQUEST":{
		message:"ERR_BAD_REQUEST",
		callback:(_fx)=>{_fx();}
	}, 
	"ERR_NETWORK":{
		message:"ERR_NETWORK",
		callback:(_fx,_params)=>{_fx(_params);}
	}
};
export const getSpinner=()=>{
	return(`
		<div class="d-flex justify-content-center">
			<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Loading...</span>
			</div>
		</div>
		`
		);
}
export const requestPost=(_url,param=null)=>{
	var config = {
		method: 'post',
		url: _url,
		data:param
	  };
	return axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				return(response.data);
			}
			return(null);
		}).catch((response)=>{
			return(null);
		})
}
export const requestGet=(_url,param=null)=>{
	var config = {
		method: 'post',
		url: _url,
		data:param
	  };
	return axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				return(response.data);
			}
			return(null);
		}).catch((response)=>{
			return(null);
		})
}
